<template>
<CContainer fluid>
  <CRow class="card-kid-print" >
    <CRow lg="12">
      <CCol>
        <CCard >
          <CRow >
            <CCol  >
              <CCardBody >
                <CRow class="d-flex justify-content-center" >
                  <div style="font-size: 14px; font-weight: bold; margin-bottom: 10px;">IFGF KID PICK-UP CARD</div>
                </CRow>
                <Crow class="d-flex justify-content-center">
                  <img width="105" height="auto" v-bind:src="getQR(datas.data.barcode)"/>
                </Crow>
                  <Crow>
                      <hr>
                      Name: <b> {{datas.data.firstname + " " + datas.data.lastname}} </b>
                      <br> Gender:<b> {{datas.data.sex}}</b> 
                      <br> Class: <b> {{datas.data.ikid_class.name }} </b> 
                      <br> Dad: <b> {{ dad }}  </b>
                      <br> Mom: <b> {{ mom }} </b> 
                      <br> Check In Time: <b> {{(datas.data.checkin_status.log_time)}} </b> 
                  </Crow>
                    <b v-if="mode === 'reprint'" class="d-flex justify-content-center" style="color:red"> {{ " REPRINT" }}</b>
              </CCardBody>
            </CCol>
          </CRow>
        </CCard>
      </CCol>
    </CRow>
  </CRow>
    <ikidmodal></ikidmodal>
    <ikidmodalphoto></ikidmodalphoto>
    <ikidmodalnote></ikidmodalnote>
    <ikidmodalgraduate></ikidmodalgraduate>
    <alertmodal></alertmodal>
  </CContainer>
</template>

<script>  
import moment from 'moment';
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

import ikid from '@/services/ikid'
import axios from 'axios'
import ikidmodal from './ikidsmodal.vue';
import ikidmodalphoto from './ikidsmodalphoto.vue';
import ikidmodalnote from './ikidsmodalnote.vue';
import ikidmodalgraduate from './ikidsmodalgraduate.vue';
import debounce from 'lodash/debounce'

import store from '@/store.js'

export default {
name: 'detailmodal',
components: { ikidmodal, alertmodal, ikidmodalphoto, ikidmodalnote, ikidmodalgraduate },
  data () {
    return {
      accordion: '',
      mode: '',
      datas:[],
      dob:'',
      dad:'',
      dad_id:'',
      mom:'',
      mom_id:'',
      qrcode:'',
      form:{
        uuid:''
      }
      }
  },

  mounted() {
  document.onreadystatechange = () => { 
    if (document.readyState == "complete") { 
        this.load()
        this.getQR()
    }  
  }
  window.setTimeout(function(){
    window.print()
    }, 2000);
  }, 


 methods:{
   getPhoto(data){
        if (data){
            return axios.defaults.baseURL + '/getfile/' + data.path + '/' + data.filename
        }else{
            return axios.defaults.baseURL + '/getfile/memberphoto/no_photo.jpg'
        } 
     
    },
    
    load(){
        ikid.getIkidbyID(this.$route.query.id,this.$route.query.mode)
        .then(res => {
            this.datas = res;
            this.dob = moment(res.data.dob).format ('DD MMMM YYYY')
            this.dad = res.data.dad.firstname + " " + res.data.dad.lastname
            this.mom = res.data.mom.firstname + " " + res.data.mom.lastname
            this.qrcode = process.env.VUE_APP_URL + "/getqrcode/".res.data.uuid;    
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
        this.mode = this.$route.query.mode 
    },

    getQR(value){
        return  process.env.VUE_APP_URL + '/getqrcode/' + value;
      },

    show_parent: function(uuid){ 
      this.$router.push({name:'Member Detail',query: {Pud:uuid} }) 
    },

    // graduate(id){
    //     ikid.graduate(id)
    //     .then(res => {
    //       EventBus.$emit('PAGE_UPDATE', true)
    //       var params = {title: 'Success', mode:'success', data:res.message}
    //       EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     }).catch ((err) => {
    //         var params = {title: 'Error', mode:'danger', data:err.response.data.message}
    //         EventBus.$emit('OPEN_MODAL_ALERT', params)
    //     })
    // },    
    openModalGraduate(id){
      //SET PERMISSION EACH FEATURE
      // let Permission = store.state.user.authenticated.permission
      // if (typeof Permission != 'undefined') {
      //   if(Permission.indexOf('Add/edit kid note') !== -1){
          //IF ALLOW
        var params = {title: 'Need Additional Information?', mode:'create', data:id}
        EventBus.$emit('OPEN_MODAL_IKID_GRADUATE', params)
        //END ALLOW
      //   }else{
      //     //IF NOT
      //     var params = {title: 'Error', mode:'danger', data:'unautenticated'}
      //     EventBus.$emit('OPEN_MODAL_ALERT', params)
      //     console.log(' open modal edit')
      //   } 
      // }
      //SET END
        console.log('load graduate')
    },
  }  
}

</script>

<style scoped>
  .card-kid-print{
    width: fit-content;
    padding: 10px;
    border-radius: 4px;
    
  }
</style>
